import * as R from 'ramda';
const isValidNumber = R.both(R.is(Number), R.complement(R.equals(NaN)));

const validateContacts = (contacts, types) => {
  contacts.forEach(contact => {
    if (contact.firstName && contact.lastName && contact.email && contact.phone && contact.type) {
      types[contact.type] = true;
    }
  });
  return Object.keys(types)
               .filter(key => !types[key])
               .map(key => ({
                 value: 1,
                 warning: `Add a ${key} contact.`,
                 scrollTo: () => {
                   const scrollToAnchor = () => {
                     const element = document.querySelector('#contactsNode');
                     if (element) scrollTo('#contactsNode', { offset: -70 });
                   };
                   scrollToAnchor();
                 },
               }));
};

export default {

  String(value) {
    if (typeof value !== 'string' || value === '') return false;
  },

  Number(value) {
    if (typeof value !== 'number') return false;
  },

  Contact(contacts) {
    if (contacts && contacts.length) return true;
    return false;
  },

  LocationContact(contacts) {
    if (contacts && contacts.length) return true;
    return false;
  },

  Address(address) {
    if (typeof address !== 'object' || !address.addressOne) return false;
  },

  BeddingConfig({ rooms }) {
    return !R.isNil(rooms) && !R.isEmpty(rooms) && R.call(R.compose(
      R.all(R.allPass([R.has('bedType'), R.has('count')])),
      R.flatten
    ), rooms);
  },

  Rating(rating, model) {
    if (model.productType !== 'accommodation') return undefined;
    else if (typeof rating !== 'object' || typeof rating.value !== 'number' || typeof rating.type !== 'string') return false;
  },

  Exact(expected, value) {
    if (expected !== value) return false;
  },

  Array(value) {
    if (!Array.isArray(value) || !value.length) return false;
  },

  roomCountInfo(roomCountInfo) {
    if (typeof roomCountInfo !== 'object' || !roomCountInfo.unit) return false;
  },

  tourDuration(tourDuration, model) {
    if (typeof tourDuration !== 'object') return false;
    if (model.tourDurationDoesNotApply) return true;
    if (tourDuration.unit !== undefined && tourDuration.value !== undefined && tourDuration.value !== 0) return true;
    if (tourDuration.value === 0) return false;
    if (typeof tourDuration !== 'object' || !tourDuration.unit) return false;
    return false;
  },

  productInfo(productInfo) {
    if (typeof productInfo !== 'object' ||
      typeof productInfo.include !== 'string' ||
      productInfo.include === '' ||
      typeof productInfo.exclude !== 'string' ||
      productInfo.exclude === '' ||
      typeof productInfo.whatToBring !== 'string' ||
      productInfo.whatToBring === '') {
      return false;
    }
  },

  totalMaxPassengers(val) {
    return isValidNumber(parseInt(val, 10));
  },

  totalMinPassengers(val) {
    return isValidNumber(parseInt(val, 10));
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/object-types.js